<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        dark
        right
        absolute
        v-on="on"
        @click="mostrarModal"
      >
        Ver Solicitud
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Datos de Solicitud</v-card-title>

      <v-card-text>
        <v-text-field
          label="Código de Solicitud"
          v-model="request"
          required
        />
      </v-card-text>

      <v-card-text style="height: 100%" v-if="requestForm">

        <!-- Datos básicos -->
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Nombre"
              v-model="requestForm.name_applicant"
              readonly
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Apellido"
              v-model="requestForm.first_lastname_applicant"
              readonly
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Servicio"
              v-model="requestForm.services_applicant"
              readonly
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Tipo de solicitud"
              v-model="requestForm.request_type.name"
              readonly
            />
          </v-col>
        </v-row>

        <v-text-field
          label="Estado"
          v-model="requestForm.state"
          readonly
          background-color="#FDFD92"
        />

        <v-row>
          <v-col cols="12" sm="10">
            <v-text-field
              v-model="requestForm.document_identification_name"
              label="Cédula de identidad"
              readonly
            />
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn
              color="teal"
              style="color: white"
              outlined
              @click="() => openFile(requestForm.document_identification)"
            >
              <v-icon dark>mdi-eye</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Archivos adjuntos -->
        <v-card-title>Archivos Adjuntos</v-card-title>
        <v-data-table
          v-if="requestForm.files && requestForm.files.length"
          :headers="headers"
          :items="requestForm.files"
          item-key="created_at"
          class="elevation-2 mb-6"
          :loading="loading"
          loading-text="Cargando... Favor de esperar"
        >
          <template v-slot:[`item.file_name`]="{ item }">
            {{ item.file_name }}
          </template>
          <template v-slot:[`item.file`]="{ item }">
            <v-btn
              color="teal"
              style="color: white"
              outlined
              @click="() => openFile(item.file)"
            >
              <v-icon dark>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Historial de observaciones -->
        <v-card-title>Historial de Observaciones</v-card-title>
        <v-data-table
          v-if="requestForm.histories && requestForm.histories.length"
          :headers="headersHistories"
          :items="requestForm.histories"
          item-key="id"
          class="elevation-2"
          dense
        >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
          <template v-slot:[`item.observations`]="{ item }">
            <pre style="white-space: pre-wrap; font-size: 14px;">{{ item.observations }}</pre>
          </template>
        </v-data-table>

        <v-overlay :value="loading" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card-text>

      <v-card-actions flat>
        <v-btn @click="dialog = false" color="secondary">Cerrar</v-btn>
        <v-btn @click="searchCode" color="info" right absolute>Buscar Solicitud</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { RequestService } from "../../services/models/request.js";

export default {
  props: ["code"],
  data() {
    return {
      dialog: false,
      loading: false,
      request: this.code != undefined ? this.code : "",
      requestForm: null,
      headers: [
        { text: "Nombre documento", value: "file_name" },
        { text: "Archivo", value: "file" },
      ],
      headersHistories: [
        { text: "Fecha", value: "created_at", sortable: false },
        { text: "Observaciones", value: "observations", sortable: false },
      ],
    };
  },
  methods: {
    async mostrarModal() {
      this.dialog = true;
      if (this.code != undefined) {
        this.searchCode();
      }
    },
    async searchCode() {
      this.loading = true;
      try {
        const requestCode = await RequestService.getByRequestCode(this.request);
        this.requestForm = requestCode[0];
      } catch (error) {
        console.error("Error al buscar solicitud:", error);
      } finally {
        this.loading = false;
      }
    },
    openFile(file) {
      window.open(file, "_blank");
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleString("es-CL", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
  },
};
</script>
